import React, { useMemo } from 'react'

import View from '../../../../components/pdf/View'
import Text from '../../../../components/pdf/Text'
import Separator from '../../../../components/pdf/Separator'
import { Table, TableCol, TableRow } from '../../../../components/pdf/Table'
import { TableColText, TableHeadText } from '../../../../components/pdf/TableHelpers'
import {
  findReplyByQuestionId,
  getReplyValue,
  toDateFormat,
  filterRepliesByQuestionType,
  toPtNumber,
  findReplyByQuestionName
} from '../_helpers/pdfHelpers'
import { useServiceOrder } from '../_load/ServiceOrderLoader'
import Image from '../../../../components/pdf/Image'

const cleanText = text => text.trim().replace(/[\t\n\\"]/g, '')

const questionWeights = {
  'A obra possui o F-OBR-29 Programa de gerenciamento de resíduos da construção civil devidamente atualizado e na revisão correta ?': 2,
  'O documento possui as descrições corretas solicitadas do empreendimento (Dados do empreendimento/Responsável técnico/Endereço e CNPJ) ?': 1,
  'No documento possui a indicação dos responsáveis pela destinação final de cada resíduos gerado no canteiro - (tipo de resíduos, empresa responsável e destinação dos resíduos) ?': 2,
  'Possui no documento previsão dos resíduos sólidos gerados com seu volume e caracterização de tipo de respiduo conforme CONAMA 307/2020 ?': 2,
  'A obra realiza processos de reutilização ou reciclagem visando uma minimização na geração de resíduos ?': 1,
  'A obra possui em sua ART de execução e/ou específica do PGRCC com  responsabilidade técnica pela elaboração e implementação do PGRCC ?': 1,
  'A obra foi cadastrada como grande gerador de resíduos inertes e sólidos atraves da prefeitura vigente com a região ?': 2,
  'A obra possui a pasta física Gestão de Resíduos ?': 1,
  'Para o transporte dos resíduos gerados dentro do canteiro de obra Classe A; B; C e D: - As empresas que realizam essas atividades, são devidamentes licenciadas ?': 2,
  'Para as empresas responsáveis pela destinação final dos resíduos perigosos e não perigosos: - Os destinadores finais, possuem as devidas licenças ambientais ?': 3,
  'A obra possui as MTRs referente as saídas dos resíduos perigosos da obra, com indicação de tipo de resíduo, quantidade, empresa transportadora (CNPJ conforme contrato), empresa de destinação final (CNPJ conforme contrato) e endereço do local de destinação conforme o contrato, com assinatura ou registro eletrônico equivalente de todos os envolvidos ?': 3,
  'A obra possui as CTRs referente as saídas dos resíduos da obra, com indicação de tipo de resíduo, quantidade, empresa transportadora (CNPJ conforme contrato), empresa de destinação final (CNPJ conforme contrato) e endereço do local de destinação conforme o contrato, com assinatura ou registro eletrônico equivalente de todos os envolvidos ?': 3,
  'A compra dos agregados foi feita de acordo com os procedimentos interno da empresa ? - Fornecedores com licenças ambientais de extração e exploração, Alvarás de funcionamentos e licenças de operação entre outras licenças ?': 2,
  'Os resíduos gerados no canteiro são levados por veículos licenciados pela Prefeitura conferindo a CTR?': 2,
  'Para a armazenagem dos resíduos perigosos: - Possui uma baia especifica e sinalizada, esta separado dos demais resíduos (Gerclear) ?': 2,
  'A FDS está fixada  no local de armazenamento e manuseio do produto?': 2,
  'O local de estocagem de líquidos inflamáveis e combustíveis foi adequado corretamente de acordo as normas de segurança e meio ambiente NBR12235 construído com material não inflamável, piso impermeável com caixa de contenção, cercado e trancado, munido com sinalização apropriada, extintores de incêndio em número adequado, identificação dos mesmos nos recipientes existentes, além de serem instalados longe de locais com trânsito ou permanência de colaboradores ?': 3,
  'Os resíduos inertes da gerados no cantero estão sendo acondicionados em baias ou caçambas, separados e identificados?': 2,
  'Os resíduos orgânicos estão isolados de outros resíduos e do solo?': 2,
  'A obra possui kit mitigação/kit de proteção ambiental conforme F-OBR-29 ?': 2,
  'As espécies vegetais que se encontram no terreno foram preservadas?': 2,
  'Estão de acordo as condições de acondicionamento dos resíduos que permitem o seu reuso e reciclagem de acordo com o PGRCC ?': 2,
  'Os objetivos e metas ambientais definidos no relatório gerencial são divulgados de forma adequada a todos os colaboradores (Engenharia) ?': 2,
  'A obra está realizando o preenchimento da plataforma Cecarbon de acordo com a fase de construção ?': 2,
  'Os indicadores de Meio Ambiente e resultados das inspeções ambientais: - São analisados mensalmente? - Esta análise é realizada em conjunto pelo Gestor da Obra?': 1,
  'Existe sinalização ou campanha para garantir a redução do consumo de insumos (Energia e Água)?': 2,
  'Os colaboradores da obra foram treinados em relação aos procedimentos?': 2,
  'A obra está sinalizada conforme I-OBR-01 Canteiro de obras?': 1,
  'As ruas e calçadas em torno do canteiro de obras estão limpas?': 2,
  'Foi implantado o lava rodas conforme I-OBR-01 Canteiros de Obras?': 1,
  'A obra está acompanhando a inspeção de fumaça preta, utilizando o F-OBR-17 Controle de emissões?': 1,
  'Água potável, quando fornecida por caminhão pipa, foi fornecida por empresa que possui Outorga de Direito de Uso da Água emitida pelo Departamento de Águas e Energia Elétrica (DAEE) referente à captação, armazenamento e transporte da água ?': 2,
  'A obra realizou o ensaio de retirada de água do lençol freático pela via pública, contratando laboratório credenciado pelo INMETRO?': 1,
  'As águas potáveis destinadas ao abastecimento são analisadas semestralmente conforme Portaria 2914/11 do Ministério da Saúde (padrões de potabilidade)?': 1
}

const replyIdsByCategory = {
  'PROGRAMA DE GERENCIAMENTO DE RESÍDUOS CONSTRUÇÃO CIVIL (PGRCC)': [132, 133, 330, 7034, 135, 7039],
  'GERENCIAMENTO DE RESÍDUOS SÓLIDOS': [
    168, 169, 170, 7044, 171, 172, 173, 7049, 349, 350, 351, 878, 173, 174, 7054, 175, 176, 177, 178, 179, 180
  ],
  'DIVULGAÇÕES E MONITORAMENTO': [187, 188, 189, 190, 191, 192, 193, 194, 195],
  'CONTROLE E GERENCIAMENTO DE ÁGUAS': [196, 197, 198],
  EVIDÊNCIAS: [186]
}

const RequirementReplies = ({ replyIds, totalPesos }) => {
  const { replies } = useServiceOrder()

  const validReplies = replyIds.filter(replyId => {
    const reply = findReplyByQuestionId(replies, replyId)
    if (!reply || !reply.value) return false
    const replyValue = getReplyValue(reply).trim()
    return replyValue !== 'N/A'
  })

  return (
    <>
      {validReplies.map(replyId => {
        const reply = findReplyByQuestionId(replies, replyId)
        const replyValue = getReplyValue(reply).trim()
        const absoluteValue = Number(replyValue.split('=')[0])
        let value
        let peso = 0
        let questionName = cleanText(reply?.question?.name)
        if (typeof absoluteValue === 'number') {
          peso = questionWeights[questionName]
          value = absoluteValue
        } else {
          value = 'ÑAPLICA'
        }
        return (
          <TableRow key={replyId}>
            <TableCol>{reply.question.name}</TableCol>
            <TableCol>
              <Text bold align={'center'}>
                {value}
              </Text>
            </TableCol>
          </TableRow>
        )
      })}
    </>
  )
}

const Requirement = ({ categoryName, replyIds, totalPesos, data }) => {
  const { replies } = useServiceOrder()

  const hasValidReplies = replyIds.some(replyId => {
    const reply = findReplyByQuestionId(replies, replyId)
    if (!reply || !reply.value) return false
    const replyValue = getReplyValue(reply).trim()
    return replyValue !== 'N/A'
  })

  if (!hasValidReplies) {
    return null
  }

  return (
    <>
      <TableRow>
        <TableColText colSpan={4} bold bgColor={'#BFBFBF'} align="center">
          {categoryName}
        </TableColText>
      </TableRow>
      <RequirementReplies replyIds={replyIds} totalPesos={totalPesos} />
    </>
  )
}

const hasValidNotas = replies => {
  return Object.keys(questionWeights).some(question => {
    const reply = replies.find(reply => cleanText(reply.question.name) === cleanText(question))

    if (!reply || !reply.value) return false
    const replyValue = getReplyValue(reply).trim()
    if (replyValue === 'N/A') return false

    return reply?.value?.name.startsWith('1') || reply?.value?.name.startsWith('2')
  })
}

const Notas = ({ replies }) => {
  if (!hasValidNotas(replies)) {
    return null
  }

  return (
    <Table width="100%">
      <TableRow>
        <TableHeadText width={'70%'} align="center" bold={false}>
          Apontamentos para notas 1 e 2
        </TableHeadText>
        <TableHeadText align="center" bold={false}>
          Graduação
        </TableHeadText>
        <TableHeadText align="center" bold={false}>
          Causas (aplicável apenas para não conformidades)
        </TableHeadText>
      </TableRow>
      {Object.keys(questionWeights).map((question, index) => {
        const reply = replies.find(reply => cleanText(reply.question.name) === cleanText(question))

        if (!reply || !reply.value) {
          return null
        }

        const replyValue = getReplyValue(reply).trim()
        if (replyValue === 'N/A') {
          return null
        }

        if (reply?.value?.name.startsWith('1') || reply?.value?.name.startsWith('2')) {
          const childrenReplies = replies.filter(r => r.question.parentReference === reply.question.reference)
          const requisito = findReplyByQuestionName(childrenReplies, 'Requisito')
          const fato = findReplyByQuestionName(childrenReplies, 'Fato')
          const evidencia = findReplyByQuestionName(childrenReplies, 'Evidência')

          return (
            <TableRow key={index}>
              <TableColText width={'70%'}>
                <b>Requisito: </b>
                {requisito?.value}
                <br />
                <b>Fato: </b>
                {fato?.value}
                <br />
                <b>Evidência: </b>
                {evidencia?.value}
              </TableColText>
            </TableRow>
          )
        } else {
          return null
        }
      })}
    </Table>
  )
}

const Fotos = ({ replies }) => {
  const images412 = findReplyByQuestionId(replies, 131)
  const otherImages = filterRepliesByQuestionType(replies, 'gallery')
    .map(reply => reply.value)
    .flat()

  const allImages = [].concat(images412?.value?.length ? images412.value : []).concat(otherImages)

  if (!allImages?.length) return <></>
  return (
    <>
      <Separator weight={4} />
      <Table width="100%" style={{ pageBreakInside: 'auto', pageBreakAfter: 'auto' }}>
        <TableRow>
          <TableColText bold align="center">
            {'Fotos'}
          </TableColText>
        </TableRow>
        {allImages.map(image => {
          return (
            <TableRow key={image?.id} style={{ paddingTop: '10px', pageBreakInside: 'auto', pageBreakAfter: 'auto' }}>
              <TableCol style={{ padding: '5px' }}>
                <Image src={image?.src} maxWidth={280} ignoreFixedSize />
              </TableCol>
            </TableRow>
          )
        })}
      </Table>
    </>
  )
}

const Content = () => {
  const { replies, place, endDate, user } = useServiceOrder()
  const date = toDateFormat(endDate, 'DD/MM/YYYY')

  const auditedTeam = getReplyValue(findReplyByQuestionId(replies, 7107))

  const totalPesos = useMemo(() => {
    let total = 0
    Object.keys(questionWeights).forEach(question => {
      const reply = replies.find(reply => reply.question.name.trim() === question.trim())

      if (!reply || !reply.value) {
        return
      }

      const replyValue = getReplyValue(reply).trim()

      if (replyValue === 'N/A') {
        return
      }

      const absoluteValue = Number(replyValue.split('=')[0])
      let peso = 0
      if (typeof absoluteValue === 'number') {
        peso = questionWeights[question]
      }
      total = total + peso
    })
    return total
  }, [replies])

  const data = useMemo(() => {
    let dados = {}
    Object.keys(questionWeights).forEach(question => {
      const reply = replies.find(reply => cleanText(reply.question.name) === cleanText(question))

      if (!reply || !reply.value) {
        return
      }

      const replyValue = getReplyValue(reply).trim()

      if (replyValue === 'N/A') {
        return
      }

      const replyNumber = Number(replyValue.split('=')[0])
      let value
      let peso = 0
      let finalPercent = 0
      let finalWeight = 0
      if (typeof replyNumber === 'number') {
        let questionName = cleanText(reply?.question?.name)
        peso = questionWeights[questionName]
        value = replyNumber
        finalWeight = (peso * (peso / totalPesos) * 100) / 100

        if (replyNumber > 2) {
          finalPercent = 100
        }
      } else {
        value = 'ÑAPLICA'
      }

      dados[question] = {
        reply: value,
        weight: finalWeight,
        percent: finalWeight * finalPercent
      }
    })
    return dados
  }, [replies, totalPesos])

  const resumo = useMemo(() => {
    let totalPeso = 0
    let percentFinal = 0

    Object.keys(data).forEach(question => {
      let { weight, percent } = data[question]
      weight = weight ? Number(weight) : 0
      percent = percent ? Math.round(Number(percent) * 100) / 100 : 0
      totalPeso += weight
      percentFinal += percent
    })

    return { totalPeso, percentFinal }
  }, [data])

  return (
    <>
      <View pageBreakAfter>
        <Text size={'small'}>
          <Table width="100%">
            <tr style={{ border: '1px solid black' }}>
              <td style={{ width: '141px' }}>
                <Text align={'center'} bold>
                  Objetivo e escopo:
                </Text>
              </td>
              <td>
                <Text>
                  Objetivo e escopo: Avaliar a aderência aos procedimentos aplicáveis à área e ao processo com base na
                  ISO 9001:2015, SiAC: 2021 - Nível A.
                </Text>
              </td>
            </tr>
            <tr style={{ border: '1px solid black' }}>
              <td style={{ width: '141px' }}>
                <Text align={'center'} bold>
                  Obra:
                </Text>
              </td>
              <td>
                <Text>{place.name}</Text>
              </td>
            </tr>
            <tr style={{ border: '1px solid black' }}>
              <td style={{ width: '141px' }}>
                <Text align={'center'} bold>
                  Data:
                </Text>
              </td>
              <td>
                <Text>{date}</Text>
              </td>
            </tr>
            <tr style={{ border: '1px solid black' }}>
              <td style={{ width: '141px' }}>
                <Text align={'center'} bold>
                  Auditor(es):
                </Text>
              </td>
              <td>
                <Text>{user.name}</Text>
              </td>
            </tr>
            <tr style={{ border: '1px solid black' }}>
              <td style={{ width: '141px' }}>
                <Text align={'center'} bold>
                  Equipe auditada:
                </Text>
              </td>
              <td>
                <Text>{auditedTeam}</Text>
              </td>
            </tr>
          </Table>
          <Separator weight={4} />
          <Table width="30%">
            <TableRow>
              <TableColText bold align="center">
                {'ADERÊNCIA'}
              </TableColText>
            </TableRow>
            <TableRow>
              <TableCol style={{ padding: '5px' }}>{'1 = Não cumpre o requisito'}</TableCol>
            </TableRow>
            <TableRow>
              <TableCol style={{ padding: '5px' }}>{'2 = Cumpre parcialmente o requisito'}</TableCol>
            </TableRow>
            <TableRow>
              <TableCol style={{ padding: '5px' }}>{'3 = Cumpre o requisito'}</TableCol>
            </TableRow>
          </Table>
          <Separator weight={4} />
          <Table width="100%" style={{ pageBreakInside: 'auto', pageBreakAfter: 'auto' }}>
            <TableRow>
              <TableHeadText width={'85%'} bgColor={'#558ed5'} align="center" color={'white'} bold={false}>
                PROCEDIMENTO DE OBRAS - P-OBR-01
              </TableHeadText>
              <TableHeadText bgColor={'#558ed5'} align="center" color={'white'} bold={false}>
                %Final
              </TableHeadText>
            </TableRow>
            <TableRow>
              <TableColText bold align="left">
                {'OBRAS'}
              </TableColText>
              <TableColText bold align="center">
                {toPtNumber(parseFloat((resumo.percentFinal / resumo.totalPeso).toFixed(2)))}%
              </TableColText>
            </TableRow>

            <Requirement
              data={data}
              categoryName={'PROGRAMA DE GERENCIAMENTO DE RESÍDUOS CONSTRUÇÃO CIVIL (PGRCC)'}
              replyIds={replyIdsByCategory['PROGRAMA DE GERENCIAMENTO DE RESÍDUOS CONSTRUÇÃO CIVIL (PGRCC)']}
              totalPesos={totalPesos}
            />

            <Requirement
              data={data}
              categoryName={'GERENCIAMENTO DE RESÍDUOS SÓLIDOS'}
              replyIds={replyIdsByCategory['GERENCIAMENTO DE RESÍDUOS SÓLIDOS']}
              totalPesos={totalPesos}
            />

            <Requirement
              data={data}
              categoryName={'DIVULGAÇÕES E MONITORAMENTO'}
              replyIds={replyIdsByCategory['DIVULGAÇÕES E MONITORAMENTO']}
              totalPesos={totalPesos}
            />

            <Requirement
              data={data}
              categoryName={'CONTROLE E GERENCIAMENTO DE ÁGUAS'}
              replyIds={replyIdsByCategory['CONTROLE E GERENCIAMENTO DE ÁGUAS']}
              totalPesos={totalPesos}
            />
          </Table>
          <Separator weight={4} />
          <Notas replies={replies} />
        </Text>
      </View>
      <Separator weight={4} />
      <View pageBreakAfter>
        <Fotos replies={replies} />
      </View>
    </>
  )
}

export default Content
